/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react';
import { injectStripe, PaymentRequestButtonElement } from 'react-stripe-elements';
import { connect } from 'react-redux';
import Moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes from 'prop-types';

import CardSection from '../CardSection';
import CvcSection from '../CvcSection';
import ExpirySection from '../ExpirySection';
import CouponCodeSection from '../CouponCodeSection';
import TaPricingNotification from '../../TaPricingNotification';
import withStatsig from '../../hocs/withStatsig';
import PaymentMethodList from '../../PaymentMethodList';
import { CheckBox } from '../../Form';
import paymentsConstants from '../../../../constants/payments';
import { getClickAttrs } from '../../Analytics/gtag';

import styles from '../../Form/themeV3.scss';
import { showErrorPopup } from '../../../actions/notification-actions';
import { clearCardError } from '../../../actions/checkout-subscription-actions';
import { interpretStripeCardError } from '../../../utils/payments';

const { paymentFormTypes } = paymentsConstants;

class CheckoutForm extends React.Component {
    constructor() {
        super();
        this.state = {
            submitting: false,
            error: {
                name: null,
                cardNumber: null,
                cardCvc: null,
                cardExpiry: null,
            },
            defaultPaymentMethod: null,
            walletPaymentRequest: null,
            showDefaultCardPaymentPage: true,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleCardElementReady = this.handleCardElementReady.bind(this);
        // eslint-disable-next-line todo-comments/todo-comments
        // TODO (davecohen): Remove this and related code with HUB-526
        this.savedPaymentsEnabled = false;
        this.cardNumberRef = null;
    }

    componentDidMount() {
        if (this.savedPaymentsEnabled) {
            this.setDefaultCard();
        }

        if (this.props.cardError) {
            this.props.clearCardError();
        }
    }

    componentDidUpdate(oldProps) {
        if (oldProps.invoiceItems?.lineItems?.length !== this.props.invoiceItems?.lineItems?.length || oldProps.invoiceItems?.total?.amount !== this.props.invoiceItems?.total?.amount) {
            this.initWalletPaymentRequest();
        }
    }

    handlePaymentMethodReceived = async (paymentRequestResult) => {
        const { onSuccess } = this.props;
        this.setState({ error: null, submitting: true });
        onSuccess(paymentRequestResult.paymentMethod.id, true, true, paymentRequestResult);
    };

    setDefaultCard = () => {
        const { playerPaymentMethods, formType, setUsingStripeForm, setIsPaymentByDefaultCard } = this.props;
        if (playerPaymentMethods?.length) {
            const defaultPaymentMethod = playerPaymentMethods.find((card) => card.isDefaultPaymentMethod && !card.isExpired);
            if (defaultPaymentMethod) {
                this.setState({
                    defaultPaymentMethod,
                });
            } else {
                this.setState({ showDefaultCardPaymentPage: false });
                setIsPaymentByDefaultCard(false);
            }
        } else if (formType === paymentFormTypes.cc_update) { // if there is no saved method and changing card for subscription skip mediator screen
            setUsingStripeForm(true);
        }
    };

    checkAllSavedCardsExpired = () => {
        const { playerPaymentMethods = [] } = this.props;
        const expiredCards = playerPaymentMethods?.filter(card => card.isExpired);
        return expiredCards.length === playerPaymentMethods.length;
    };

    initWalletPaymentRequest = () => {
        const { stripe, formType, invoiceItems, setUsingStripeForm } = this.props;
        if (stripe && formType === paymentFormTypes.powered) {
            const paymentRequestInstance = stripe.paymentRequest({
                country: 'US',
                currency: 'usd',
                total: {
                    label: 'Total',
                    amount: invoiceItems.total.amount.toFixed(2) * 100,
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });
            // Check the availability of the Payment Request API.
            paymentRequestInstance.canMakePayment().then(result => {
                if (result) {
                    paymentRequestInstance.on('paymentmethod', this.handlePaymentMethodReceived);
                    this.setState({ walletPaymentRequest: paymentRequestInstance });
                } else if (this.checkAllSavedCardsExpired()) { // if no wallet activated and no saved card
                    setUsingStripeForm(true);
                }
            });
        }
    };

    // function to select to use new card
    handleAddNewCard = () => {
        const { setUsingStripeForm } = this.props;
        this.setState({ defaultPaymentMethod: null });
        setUsingStripeForm(true);
    };

    // function to change the saved card
    changePaymentMethod = () => {
        const { submitting } = this.state;
        if (!submitting) {
            const { setIsPaymentByDefaultCard } = this.props;
            this.setState({ showDefaultCardPaymentPage: false });
            setIsPaymentByDefaultCard(false);
        }
    };

    // select new card from saved cards
    selectPaymentMethod = (card) => {
        this.setState({ defaultPaymentMethod: card });
    };

    shouldRenderPaymentMethodList = usingStripeForm => {
        const { formType } = this.props;
        return (formType === paymentFormTypes.powered || formType === paymentFormTypes.cc_update) && !usingStripeForm && this.savedPaymentsEnabled;
    };

    submitButtonAndBillingDetails = () => {
        const { submitting, error } = this.state;
        const { disabled, trialAvailability, formType, invoiceItems, buttonText } = this.props;
        const hasFormErrors = error && (error.name || error.cardNumber || error.cardCvc || error.cardExpiry);
        return (
            <div>
                <button
                    className={`btn btn-xl btn-primary text-uppercase font-weight-normal w-100 ${(submitting || this.props.submitting) ? 'text-dark' : ''}`}
                    disabled={submitting || disabled || this.props.submitting || hasFormErrors}
                    {...getClickAttrs({
                        category: 'Checkout Started',
                        context: `${formType} Form Checkout`,
                        location: 'Checkout Form CTA',
                    })}
                >
                    {(submitting || this.props.submitting) && (<i className="fas fa-circle-notch fa-spin mr8" />)}
                    {buttonText}
                </button>

                {trialAvailability.data.endDate && formType === paymentFormTypes.powered && invoiceItems && (
                    <div className={'text-center mt16'}>
                        You will not be charged during your trial period. You will be billed {invoiceItems.total.currency}{invoiceItems.total.amount.toFixed(2)} on {Moment(trialAvailability.data.endDate).format('MMMM Do, YYYY')}. You may cancel at anytime.
                    </div>
                )}

                {trialAvailability.data.endDate && this.props.formType === 'pro_club_college' && this.props.lineItem !== null && (
                    <div className={'text-center mt16'}>
                        You will not be charged during your trial period. You will be billed {this.props.invoiceItems.total.currency}{this.props.invoiceItems.total.amount.toFixed(2)} on {Moment(trialAvailability.data.endDate).format('MMMM Do, YYYY')}. You may cancel at anytime.
                    </div>
                )}
            </div>
        );
    };

    walletPaymentButton = () => {
        const { walletPaymentRequest, showDefaultCardPaymentPage } = this.state;
        if (walletPaymentRequest && showDefaultCardPaymentPage && this.props.formType === 'powered') {
            const paymentButtonStyles = {
                paymentRequestButton: {
                    type: 'default',
                    theme: 'dark',
                    borderRadius: '24px',
                    width: '99%',
                },
            };
            return (<><PaymentRequestButtonElement paymentRequest={walletPaymentRequest} style={paymentButtonStyles} /><hr className="hr-text" data-content="OR" /></>);
        }
        return <></>;
    };

    handleCardElementReady(element) {
        this.cardNumberRef = element;
    }

    async handleSubmit(ev) {
        const { onSuccess, stripe, dispatch, onSubmitStart } = this.props;
        ev.preventDefault();
        if (onSubmitStart) {
            onSubmitStart();
        }
        // Within the context of `Elements`, this call to createToken knows which Element to
        // tokenize, since there's only one in this group.
        const { cardholderName, error, defaultPaymentMethod } = this.state;
        if (defaultPaymentMethod) {
            this.setState({ error: null, submitting: true });
            onSuccess(defaultPaymentMethod.id, true);
        } else {
            error.name = !cardholderName ? 'You must provide a name' : null;
            this.setState({ error, submitting: true });
            try {
                const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
                    type: 'card',
                    card: this.cardNumberRef,
                    billing_details: {
                        name: cardholderName,
                    },
                });

                if (stripeError) {
                    dispatch(showErrorPopup({
                        message: 'Unable to process request',
                        error: interpretStripeCardError(stripeError),
                    }));
                } else {
                    onSuccess(paymentMethod.id);
                }

                if (this.props?.onFormSubmit) {
                    this.props.onFormSubmit();
                }
            } finally {
                this.setState({ submitting: false });
            }
        }
    }

    handleChange(ev) {
        if (ev.elementType) {
            const { error } = this.state;
            if (ev.error) {
                error[ev.elementType] = ev.error.message;
                this.setState({ error });
            } else {
                error[ev.elementType] = null;
                this.setState({ error });
            }
        }
    }

    handleNameChange(ev) {
        const { cardholderName, error } = this.state;
        const newName = ev.target.value;
        if (cardholderName && !newName) {
            error.name = 'You must provide a name';
        } else {
            error.name = null;
        }
        this.setState({ cardholderName: newName, error });
    }

    render() {
        const { cardholderName, error, submitting, defaultPaymentMethod, showDefaultCardPaymentPage } = this.state;
        const nameId = 'cardholder-name';
        const {
            lineItem,
            buttonText,
            disabled,
            cardError,
            playerPaymentMethods,
            shouldSaveCard,
            isUsingStripeForm,
            invoiceItems,
            stripe,
            formType,
            themeV3,
            hideSaveCard,
            hideCardError,
            checkGate,
            featureGates,
        } = this.props;

        const referralsEnabled = checkGate(featureGates.REFERRAL_SYSTEM);
        const couponsEnabled = checkGate(featureGates.POWER_COUPON_CODES);

        // only way to fix font
        const stripeInputStyle = {
            base: {
                fontFamily: '\'Inter\' , Arial, sans-serif',
                fontSize: '16px',
                fontWeight: 500,
                color: '#2b3339',
                '::placeholder': {
                    fontSize: '14px',
                    color: '#b9c5cd',
                },
            },
        };

        return (
            <form onSubmit={this.handleSubmit} id="checkOutForm" data-testid="checkout-form">
                {this.shouldRenderPaymentMethodList(isUsingStripeForm) ? (
                    <Scrollbars
                        style={{ height: 'calc(70vh - 50px)' }}
                        universal
                    >
                        <PaymentMethodList
                            cardList={playerPaymentMethods}
                            selectedPaymentMethod={defaultPaymentMethod}
                            handleAddNewCard={this.handleAddNewCard}
                            changePaymentMethod={this.changePaymentMethod}
                            selectPaymentMethod={this.selectPaymentMethod}
                            stripe={stripe}
                            submitting={submitting}
                            isUsedForPayment={true}
                            showDefaultCardPaymentPage={showDefaultCardPaymentPage}
                            buttonText={buttonText}
                            disabled={disabled}
                            isSubmitting={this.props.submitting}
                            formType={formType}
                            eventFee={invoiceItems?.total?.amount}
                            currencySymbol={invoiceItems?.total?.currency}
                            walletPaymentButton={this.walletPaymentButton}
                        />
                    </Scrollbars>
                ) : (
                    <>
                        <div className={`form-group form-group-xl  ${error.name && 'is-invalid'} ${themeV3 ? styles.themeV3 : ''}`}>
                            <label htmlFor={nameId}>
                                {!themeV3 && 'Cardholder Name'}
                            </label>
                            <div className={`${styles.inputWrapper} input-wrapper`}>
                                <input
                                    id={nameId}
                                    className={`${styles.formControl} form-control`}
                                    value={cardholderName}
                                    onChange={this.handleNameChange}
                                    data-testid="checkout-form.cardholder-name"
                                />
                                {themeV3 && <label>Cardholder Name</label>}
                                <div className="error-indicator" />
                            </div>
                            {error.name && <div className="invalid-feedback">{error.name}</div>}
                        </div>
                        <div className="row">
                            <CardSection
                                error={error.cardNumber}
                                onChange={this.handleChange}
                                style={stripeInputStyle}
                                onCardElementReady={this.handleCardElementReady}
                                themeV3={themeV3}
                            />
                        </div>
                        <div className="row">
                            <CvcSection
                                error={error.cardCvc}
                                onChange={this.handleChange}
                                style={stripeInputStyle}
                                themeV3={themeV3}
                            />
                            <ExpirySection
                                error={error.cardExpiry}
                                onChange={this.handleChange}
                                style={stripeInputStyle}
                                themeV3={themeV3}
                            />
                        </div>
                        {this.props.renderCardBrands?.()}
                        {this.props.isTennisAustraliaMember && (
                            <TaPricingNotification savingsPercentage={this.props.savingsPercentage} />
                        )}
                        {(referralsEnabled || couponsEnabled) && (
                            <CouponCodeSection
                                onChange={this.handleChange}
                                style={stripeInputStyle}
                                error={this.props.couponError}
                                couponCode={this.props.couponCode}
                                applyCoupon={this.props.applyCoupon}
                            />
                        )}
                        {!hideSaveCard && (this.savedPaymentsEnabled && (formType === paymentFormTypes.powered || formType === paymentFormTypes.cc_update)) && (
                            <div className="row">
                                <CheckBox
                                    id="shouldSaveCard"
                                    field="shouldSaveCard"
                                    customLabel={<span className={'text-medium text-weight-normal'}>Save Card for Faster checkout at Event Registration</span>}
                                    formGroupCssClass="col-12"
                                    controlled={true}
                                    checked={shouldSaveCard}
                                    onChange={this.props.handleSaveCardChange}
                                    data-testid="checkout-form.save-card-checkbox"
                                />
                            </div>
                        )}
                        {!hideCardError && (
                            <div className={`${cardError && 'is-invalid'}`}>
                                {cardError && <div className="invalid-feedback">{cardError}</div>}
                            </div>
                        )}
                        {this.props.renderBeforeLineItem && this.props.renderBeforeLineItem()}
                        {lineItem}
                        {this.props.renderv3powerpricing && this.props.renderv3powerpricing()}
                        {this.submitButtonAndBillingDetails()}
                    </>
                )}
            </form>
        );
    }
}

CheckoutForm.propTypes = {
    stripe: PropTypes.shape({
        createToken: PropTypes.func.isRequired,
        paymentRequest: PropTypes.func,
    }),
    onSuccess: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    formType: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    submitting: PropTypes.bool,
    cardError: PropTypes.string,
    playerPaymentMethods: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        isDefaultPaymentMethod: PropTypes.bool,
        isExpired: PropTypes.bool,
        last4: PropTypes.string,
        brand: PropTypes.string,
        expMonth: PropTypes.number,
        expYear: PropTypes.number,
    })),
    shouldSaveCard: PropTypes.bool,
    isUsingStripeForm: PropTypes.bool,
    invoiceItems: PropTypes.shape({
        total: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }),
        lineItems: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            amount: PropTypes.number,
            description: PropTypes.string,
        })),
    }),
    featureGates: PropTypes.shape({
        REFERRAL_SYSTEM: PropTypes.string,
        POWER_COUPON_CODES: PropTypes.string,
    }).isRequired,
    checkGate: PropTypes.func.isRequired,
    setUsingStripeForm: PropTypes.func,
    setIsPaymentByDefaultCard: PropTypes.func,
    trialAvailability: PropTypes.shape({
        data: PropTypes.shape({
            endDate: PropTypes.string,
        }),
    }),
    lineItem: PropTypes.node,
    couponError: PropTypes.string,
    couponCode: PropTypes.string,
    applyCoupon: PropTypes.func,
    handleSaveCardChange: PropTypes.func,
    hideSaveCard: PropTypes.bool,
    hideCardError: PropTypes.bool,
    themeV3: PropTypes.bool,
    renderv3powerpricing: PropTypes.func,
    renderBeforeLineItem: PropTypes.func,
    isTennisAustraliaMember: PropTypes.bool,
    savingsPercentage: PropTypes.number,
    onFormSubmit: PropTypes.func,
    onSubmitStart: PropTypes.func,
    renderCardBrands: PropTypes.func,
};

CheckoutForm.defaultProps = {
    disabled: false,
    submitting: false,
    cardError: null,
    playerPaymentMethods: [],
    shouldSaveCard: false,
    isUsingStripeForm: false,
    hideSaveCard: false,
    hideCardError: false,
    themeV3: false,
    renderv3powerpricing: null,
    isTennisAustraliaMember: false,
    savingsPercentage: 0,
    stripe: null,
    invoiceItems: {
        total: {
            amount: 0,
            currency: 'USD',
        },
        lineItems: [],
    },
    setUsingStripeForm: () => {},
    setIsPaymentByDefaultCard: () => {},
    trialAvailability: {
        data: {
            endDate: null,
        },
    },
    lineItem: null,
    couponError: null,
    couponCode: '',
    applyCoupon: () => {},
    handleSaveCardChange: () => {},
    onFormSubmit: null,
    onSubmitStart: null,
    renderCardBrands: null,
    renderBeforeLineItem: null,
};

function mapDispatchToProps(dispatch) {
    return {
        clearCardError: () => dispatch(clearCardError()),
    };
}

export default injectStripe(withStatsig(connect(null, mapDispatchToProps)(CheckoutForm)));
